import { c as _c } from "react/compiler-runtime";
import { useTheme } from '@precis-digital/kurama/utils';
import type { ReactElement } from 'react';
const BADGE_SIZE = 12;
export interface ActiveDotProps {
  cx?: number;
  cy?: number;
  fill: string;
}
const ActiveDot = props => {
  const $ = _c(7);
  const theme = useTheme();
  const {
    cx: t0,
    cy: t1,
    fill
  } = props;
  const cx = t0 === undefined ? 0 : t0;
  const cy = t1 === undefined ? 0 : t1;
  const half = BADGE_SIZE / 2;
  const x = cx - half;
  const y = cy - half;
  let t2;
  if ($[0] !== theme.borderRadius.xxSmall) {
    t2 = theme.borderRadius.xxSmall.replace("px", "");
    $[0] = theme.borderRadius.xxSmall;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const badgeRx = Number(t2);
  let t3;
  if ($[2] !== badgeRx || $[3] !== fill || $[4] !== x || $[5] !== y) {
    t3 = <rect x={x} y={y} width={BADGE_SIZE} height={BADGE_SIZE} rx={badgeRx} ry={badgeRx} fill={fill} strokeWidth={0} />;
    $[2] = badgeRx;
    $[3] = fill;
    $[4] = x;
    $[5] = y;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default ActiveDot;